import React, { Fragment, useState } from "react";
import "./Dropdown.css";

const BuyType = [
  {
    name: "All",
  },
  {
    name: "Buy: Digital Xpress",
    icon: "/images/icons/buy-icon.png",
  },
  {
    name: "Buy: Bank Payment",
    icon: "/images/icons/buy-icon.png",
  },
];

const SellType = [
  {
    name: "Sell: Digital Xpress",
    icon: "/images/icons/sell-icon.png",
  },
  {
    name: "Sell: Bank Payment",
    icon: "/images/icons/sell-icon.png",
  },
];

const SwapType = [
  {
    name: "Swap Xpress",
    icon: "/images/icons/swapp-icon.png",
  },
];

const getSelectedText = (selectedType) => {
  // Extract the specific part you want to display in the selected item
  const parts = selectedType.split(":");
  return parts.length > 1 ? parts[1].trim() : selectedType;
};

const TypeFilter = ({ onTypeChange }) => {
  const [isTypeActive, setIsTypeActive] = useState(false);
  const [typeSelected, setTypeSelected] = useState("All");
  const [selectedStatusImg, setSelectedStatusImg] = useState();
  return (
    <>
      <div className="select-box-wrapper">
        <div className="react-dropdown">
          <label> Type </label>
          <div
            className="react-dropdown-btn"
            onMouseEnter={(e) => {
              e.stopPropagation();
              setIsTypeActive(true);
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              setIsTypeActive(false);
            }}
          >
            <div className="selected-item">
              {typeSelected !== "All" && (
                <img src={selectedStatusImg} alt="img" />
              )}
              <p> {typeSelected} </p>
            </div>

            <img
              className={
                isTypeActive
                  ? "dropdown-down-arrow rotate-arrow"
                  : "dropdown-down-arrow"
              }
              src="/images/icons/dropdown-arrow.svg"
              alt="arrow"
            />
          </div>
          <div
            className="dropdown-space-manage"
            onMouseEnter={(e) => {
              e.stopPropagation();
              setIsTypeActive(true);
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              setIsTypeActive(false);
            }}
          ></div>
          {isTypeActive && (
            <div
              className="dropdown-content"
              onMouseEnter={(e) => {
                e.stopPropagation();
                setIsTypeActive(true);
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                setIsTypeActive(false);
              }}
            >
              <div className="filter-type-heading">
                <p> Buy </p>
              </div>

              {BuyType &&
                BuyType.map((option, index) => {
                  return (
                    <Fragment key={index}>
                      <div
                        onClick={(e) => {
                          setTypeSelected(option.name);
                          setIsTypeActive(false);
                          setSelectedStatusImg(option.icon);
                          onTypeChange(option.name); // Call callback function
                        }}
                        className={
                          option.name === typeSelected
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        <div className="dropdown-options">
                          {option.name === "All" ? (
                            ""
                          ) : (
                            <img src={option.icon} alt="icon" />
                          )}
                          <p
                            className={`${
                              option.name === typeSelected
                                ? "option-active"
                                : "option-normal"
                            }`}
                          >
                            {getSelectedText(option.name)}
                          </p>
                        </div>
                      </div>
                    </Fragment>
                  );
                })}

              <div className="filter-type-heading divided-border-line">
                <p> Sell </p>
              </div>

              {SellType &&
                SellType.map((option, index) => {
                  return (
                    <Fragment key={index}>
                      <div
                        onClick={(e) => {
                          setTypeSelected(option.name);
                          setIsTypeActive(false);
                          setSelectedStatusImg(option.icon);
                          onTypeChange(option.name); // Call callback function
                        }}
                        className={
                          option.name === typeSelected
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        <div className="dropdown-options">
                          <img src={option.icon} alt="icon" />
                          <p
                            className={`${
                              option.name === typeSelected
                                ? "option-active"
                                : "option-normal"
                            }`}
                          >
                            {getSelectedText(option.name)}
                          </p>
                        </div>
                      </div>
                    </Fragment>
                  );
                })}

              <div className="filter-type-heading divided-border-line">
                <p> Swap </p>
              </div>

              {SwapType &&
                SwapType.map((option, index) => {
                  return (
                    <Fragment key={index}>
                      <div
                        onClick={(e) => {
                          setTypeSelected(option.name);
                          setIsTypeActive(false);
                          setSelectedStatusImg(option.icon);
                          onTypeChange(option.name); // Call callback function
                        }}
                        className={
                          option.name === typeSelected
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                      >
                        <div className="dropdown-options">
                          <img src={option.icon} alt="icon" />
                          <p
                            className={`${
                              option.name === typeSelected
                                ? "option-active"
                                : "option-normal"
                            }`}
                          >
                            {option.name}
                          </p>
                        </div>
                      </div>
                    </Fragment>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TypeFilter;
